import React from 'react';
interface ILabelProps {
	className?: string;
	htmlFor:string;
	labelName: string;
}
export const CustomLabel = ({ className, htmlFor, labelName }: ILabelProps) => {
	return (
		<label className={className} htmlFor={htmlFor}>
			{labelName}
		</label>
	);
};
